import { render, staticRenderFns } from "./UserProfileEditUserAccount.vue?vue&type=template&id=32d9ea9b"
import script from "./UserProfileEditUserAccount.vue?vue&type=script&lang=js"
export * from "./UserProfileEditUserAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports